<template>
  <div class="bg-white">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row" style="min-height:100px">
        <div class="col-sm-12">
          <div class="search-bar" style="margin-bottom: 0px;">
            <br />
            <h1 class="text-center">Maintenance Mode</h1>
            <p class="text-center">We are currently performing site maintenance, please check back soon.</p>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from './nav/NavigationBar'
import DashboardFooter from './nav/Footer'
import AccountSessionUtils from "@/components/account/AccountSessionUtils";

export default {
  name: "MaintenanceMode",
  components: {
    NavigationBar,
    DashboardFooter,
    accountUtils: AccountSessionUtils
  },
  data() {
    return {

    };
  },
  mounted() {
    this.accountUtils.authorize(
        userId => {
        this.store.state.currentUserId = userId;
        },
        () => {}
    );
  },
  computed: {

  },
  methods: {
    
  }
};
</script>




// WEBPACK FOOTER //
// src/components/MaintenanceMode.vue